export const describeError = (error: unknown): string => {
  const description = formatError(error)
  return description.trim() || 'Unknown error'
}

const formatError = (error: unknown): string => {
  if (error instanceof Error) {
    const message = [error.message, error.name, error.stack].find(Boolean) ?? 'Unknown error'
    const aggregated = 'errors' in error && Array.isArray(error.errors) ? error.errors.map(describeError) : []
    const cause = error.cause === undefined ? [] : [`Cause: ${describeError(error.cause)}`]
    return [message, ...aggregated, ...cause].join('\n')
  }
  if (typeof error === 'string') return error
  if (error && typeof error === 'object') {
    if ('message' in error && typeof error.message === 'string' && error.message) return error.message
    try {
      const serialized = JSON.stringify(error, (_key, value) => typeof value === 'bigint' ? `${value}n` : value)
      return serialized && serialized !== '{}' ? serialized : Object.prototype.toString.call(error)
    } catch {
      return Object.prototype.toString.call(error)
    }
  }
  if (error === null || error === undefined) return 'Unknown error'
  switch (typeof error) {
    case 'number':
    case 'boolean':
    case 'bigint':
    case 'symbol':
    case 'function':
      return error.toString()
    default:
      return 'Unknown error'
  }
}
